// @flow weak

import _ from 'lodash';

import { isUrlBlacklisted } from '@zapier/url-utils';

export const currentUrl = state => _.get(state, ['router', 'current', 'url']);

export const getQueryParam = (state, param) =>
  _.get(state, ['router', 'current', 'query', param]);

export const getQueryParams = state =>
  _.get(state, ['router', 'current', 'query']);

export const getParams = state => _.get(state, ['router', 'current', 'params']);

export const getParam = (param, state) => (getParams(state) || {})[param];

export const getIntegerParam = (...args) => parseInt(getParam(...args), 10);

export const getIntegerQueryParam = (...args) =>
  parseInt(getQueryParam(...args), 10);

export const getBooleanQueryParam = (...args) =>
  getQueryParam(...args) === 'true';

export const getLandingPageName = state =>
  _.get(state, ['router', 'current', 'landingPageName']);

export const getCurrentHref = state =>
  _.get(state, ['router', 'current', 'location', 'href']);

export const getCurrentPathname = state =>
  _.get(state, ['router', 'current', 'location', 'pathname']);

export const getCurrentOrigin = state =>
  _.get(state, ['router', 'current', 'location', 'origin']);

export const getCurrentLocationSearch = state =>
  _.get(state, ['router', 'current', 'location', 'search']);

export const getPreviousOrigin = state =>
  _.get(state, ['router', 'previous', 'location', 'origin'], null);

export const getPreviousLocation = state =>
  _.get(state, ['router', 'previous', 'location', 'pathname'], null);

export const getPreviousLandingPageName = state =>
  _.get(state, ['router', 'previous', 'landingPageName']);

export const getPreviousParams = state =>
  _.get(state, ['router', 'previous', 'params']);

export const getCurrentHash = state =>
  _.get(state, ['router', 'current', 'location', 'hash']);

export const getCurrentRouteItem = (itemName, state) =>
  _.get(state, ['router', 'current', itemName]);

export const isCurrentUrlBlacklisted = (state, blacklist) =>
  isUrlBlacklisted(currentUrl(state), blacklist);

export const getRouteKey = state =>
  _.get(state, ['router', 'current', 'routeKey'], []);

export const getNextHref = state =>
  _.get(state, ['router', 'next', 'location', 'href'], null);

export const getNextParam = (state, param) =>
  _.get(state, ['router', 'next', 'query', param]);
